import { Box, Typography, Stack } from '@mui/material';
import type { TimeSlot } from './entity';

type TimeSlotRowProps = {
  slot: TimeSlot;
  height: number;
  onClick?: (time: string) => void;
  isHalfHour?: boolean;
};

const TimeSlotRow = ({ slot, height, onClick, isHalfHour = false }: TimeSlotRowProps) => {
  return (
    <Stack
      direction="row"
      sx={{
        height,
        borderTop: isHalfHour ? '1px dashed' : '1px solid',
        borderColor: isHalfHour ? 'divider' : 'grey.300',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'background-color 0.2s',
        '&:hover': onClick
          ? {
              backgroundColor: 'action.hover',
            }
          : {},
      }}
      onClick={() => onClick?.(slot.time)}
    >
      <Box
        sx={{
          width: 30,
          paddingX: 1,
          paddingY: 0.5,
          borderRight: '1px solid',
          borderColor: 'grey.300',
          backgroundColor: 'grey.50',
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={isHalfHour ? 400 : 600}>
          {slot.label}
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          position: 'relative',
        }}
      />
    </Stack>
  );
};

export default TimeSlotRow;
